import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that displays the DVS "Havale / EFT Avantajı" savings card.
 * Listens for variant update events and swaps in the server-rendered card for
 * the newly selected variant. No price calculation happens in JavaScript — the
 * Liquid-rendered fragment from the updated section HTML is used as-is.
 *
 * @extends {Component}
 */
class DvsEftPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles the product select event and swaps in the updated card markup.
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newEftPrice = detail.html.querySelector(`dvs-eft-price[data-block-id="${this.dataset.blockId}"]`);
        if (!newEftPrice) return;

        this.replaceChildren(...newEftPrice.childNodes);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[dvs-eft-price] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('dvs-eft-price')) {
  customElements.define('dvs-eft-price', DvsEftPrice);
}
